<div [class.b-col-w]="whiteMode"
     [class.b-b]="expandableLayout !== 'filled'"
     [ngClass]="expandableLayout === 'filled' ? 'p-a p-t-1' : 'p-b-5'"
     [ngSwitch]="!!expandableTitle">
    <div class="flex flex-justify-between cursor-pointer col-1 "
         [ngClass]="expandableLayout ==='filled' ? 'p-t-3' : 'p-t-5'"
         (click)="toggle()">

        <!-- title -->
        <div class="flex-grow w-12 _title">
            <label [ngClass]="expandableLayout ==='filled' ? 'p2' : 's1'"
                   class="cursor-pointer"
                   [class.col-w]="whiteMode"
                   *ngSwitchCase="true">
                {{expandableTitle}}
            </label>
            <ng-container *ngSwitchCase="false">
                <ng-container *ngTemplateOutlet="expandableTitleTpl"></ng-container>
            </ng-container>
        </div>
        <!-- icon -->
        <div [lineHeightBy]="expandableLayout ==='filled' ? 'p2' : 's1'">
            <i [ngClass]="[toggleState ? 'icon-minus' : 'icon-plus']"
               [class.col-w]="whiteMode"></i>
        </div>
    </div>

    <!-- body -->
    <div class="_animate "
         [hideUp]="toggleState">
        <div class="p-b-1">
            <ng-container *ngSwitchCase="true">
                <ng-container *ngTemplateOutlet="expandableContentTpl"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="false">
                <ng-container *ngTemplateOutlet="expandableBodyTpl"></ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #expandableTitleTpl>
    <ng-content select="[expandableTitle]"></ng-content>
</ng-template>
<ng-template #expandableBodyTpl>
    <ng-content select="[expandableBody]"></ng-content>
</ng-template>
<ng-template #expandableContentTpl>
    <ng-content></ng-content>
</ng-template>
